import OrdenesPorAcreditar from 'akasia-components/dashboards/general/ordenes-por-acreditar/OrdenesPorAcreditar';
import ErrorBoundary from 'components/common/ErrorBoundary';
import useToken from 'hooks/useToken';
import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import CuentasPorPagarWarning from './CuentasPorPagarWarning';
import AvanceGraficoAnual from './AvanceMetas/AvanceGraficoAnual';
import AvanceGraficoTrimestral from './AvanceMetas/AvanceGraficoTrimestral';
import AvanceVentaItemsTrimestre from './AvanceMetas/AvanceVentaItemsTrimestre';
import AvanceVentasItemsMes from './AvanceMetas/AvanceVentasItemsMes';
import CrmStats from './CrmStats';
import ItemGrafica from './ItemsPorVendedor/ItemGrafica';
import ModalOrdenesDeuda from './ModalOrdenesDeuda';
import TitleSelector from './TitleSelector';
import NotificacionCumple from './saludo-inicial/NotificacionCumple';
import TarjetaVentasPorCategoria from './saludo-inicial/TarjetaVentasPorCategoria';
import barChart from 'assets/img/illustrations/crm-bar-chart.png';

const Ecommerce = () => {

    const { idUsuario } = useToken();
    const [vendedores, setVendedores] = useState([]);
    const [dateQuarter, setDateQuarter] = useState(new Date());
    const [idUsuario_, setIdUsuario] = useState(() => parseInt(idUsuario, 10) || -1);
    const [mes, setMes] = useState();  //se extrae el formato de fecha de esta manera.
    const [showModalOrdenesVencidas, setShowModalOrdenesVencidas] = useState(false);

    return (
        <>
            <TitleSelector
                title1={'Akasia'}
                title2={'Sales indicators'}
                vendedores={vendedores}
                setVendedores={setVendedores}
                dateQuarter={dateQuarter}
                setDateQuarter={setDateQuarter}
                idUsuario={idUsuario_}
                setIdUsuario={setIdUsuario}
                setMes={setMes}
                barChart={barChart }
            />
            <Row className="g-3 mb-3">
                <Col>
                    <CrmStats
                        mes={mes}
                        idUsuario={idUsuario_} />
                </Col>
            </Row>
            <Row className="g-3 mb-3">
                <Col xxl={6} xl={6} md={12}>
                    <Row className="g-3 mb-3">
                        <Col xs={12}>
                            <TarjetaVentasPorCategoria
                                idUsuario={idUsuario_}
                                dateQuarter={dateQuarter}
                                mes={mes}
                            />
                        </Col>
                        <Col lg={12}>
                            <NotificacionCumple />
                        </Col>
                    </Row>
                    <Row className="g-3 mb-3">
                        <Col md={12}>
                            <CuentasPorPagarWarning
                                idUsuario={idUsuario_}
                                setShowModalOrdenesVencidas={setShowModalOrdenesVencidas}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col xxl={6} xl={6} md={12}>
                    <Row className="g-3 mb-3">
                        <Col>
                            <ErrorBoundary>
                                <AvanceVentasItemsMes
                                    mes={mes}
                                    idUsuario={idUsuario_}
                                />
                            </ErrorBoundary>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <ErrorBoundary>
                                <AvanceVentaItemsTrimestre
                                    mes={mes}
                                    idUsuario={idUsuario_}
                                />
                            </ErrorBoundary>
                        </Col>
                    </Row>
                    <Row className="g-3 mb-3">
                        <Col md={6}>
                            <ErrorBoundary>
                                <AvanceGraficoTrimestral
                                    mes={mes} />
                            </ErrorBoundary>
                        </Col>
                        <Col md={6}>
                            <AvanceGraficoAnual
                                mes={mes} />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="g-3 mb-3">
                <Col>
                    <Card className="h-100">
                        <ErrorBoundary>
                            <ItemGrafica />
                        </ErrorBoundary>
                    </Card>
                </Col>
            </Row>
            <Row className="g-3 mb-3">
                <Col md={12} xxl={12}>
                    <OrdenesPorAcreditar
                        idUsuario={idUsuario_} />
                </Col>
            </Row>


            <ModalOrdenesDeuda
                idUsuario={idUsuario_}
                showModalOrdenesVencidas={showModalOrdenesVencidas}
                setShowModalOrdenesVencidas={setShowModalOrdenesVencidas}
            />

        </>
    );
};

export default Ecommerce;
